import { render, staticRenderFns } from "./CommentLikeModal.vue?vue&type=template&id=437e4a32&"
import script from "./CommentLikeModal.vue?vue&type=script&lang=js&"
export * from "./CommentLikeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports